export default __webpack_public_path__ + "static/healthcare-software-development-company-peerbits-487e42dd3b0c3008262d8cd75ed47252.png";